export default "/images/device-1.jpg?d4bbc33d056cc82fe22148745f3e3616";